<div class="overlay-container">
    <video class="video-container" autoplay loop muted playsinline>
        <source src="LOGOALKOREX.webm" type="video/webm">
        Alkorex
    </video>
    <video #bannerAlkorex id="bannerAlkorex" autoplay playsinline>
        <source src="BANNERKOREX.webm" type="video/webm">
        Alkorex
    </video>
</div>